import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  LOCALSTORAGE_SELECTED_STATE_CODE,
  LOCALSTORAGE_SELECTED_STATE_NAME,
  ROUTE_HOME,
  PAGE_TITLE_STATE_MAPPING,
  NO_STATE_SELECTED_MESSAGE,
  NO_STATE_SELECTED_LINK_TEXT,
  STATE_MAPPING_PDF_BASE_URL,
  STATE_MAPPING_PDF_VIEWER_BASE_URL,
} from "../components/constants";
import "../App.css";

export default function StateMapping() {
  const [stateId, setStateId] = useState("");
  const [stateName, setStateName] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const storedStateId = localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_CODE);
    const storedStateName = localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_NAME);

    if (!storedStateId) {
      setError(NO_STATE_SELECTED_MESSAGE);
    } else {
      setStateId(storedStateId);
      setStateName(storedStateName || storedStateId);
    }
  }, []);

  if (error) {
    return (
      <div className="main-container">
        <h2 className="section-title">{PAGE_TITLE_STATE_MAPPING}</h2>
        <p>
          {error} Go back to the <Link to={ROUTE_HOME}>{NO_STATE_SELECTED_LINK_TEXT}</Link> page to select a state.
        </p>
      </div>
    );
  }

  const pdfFileName = `${stateId}-MAPPING.pdf`;
  const pdfLink = `${STATE_MAPPING_PDF_BASE_URL}${encodeURIComponent(pdfFileName)}`;
  const pdfUrl = `${STATE_MAPPING_PDF_VIEWER_BASE_URL}${encodeURIComponent(pdfLink)}`;

  return (
    <div className="main-container">
      <h2 className="section-title">{PAGE_TITLE_STATE_MAPPING}</h2>
      <span className="iyc-badge">
        State: <strong>{stateName || stateId}</strong>
      </span>
      <div
        style={{
          marginTop: 24,
          borderRadius: 12,
          boxShadow: "0 8px 24px rgba(19,86,191,.07)",
          background: "#fff",
          padding: 24,
        }}
      >
        <iframe
          src={pdfUrl}
          title={`State Mapping - ${stateId}`}
          width="100%"
          height="600"
          style={{ border: "none", borderRadius: 8 }}
          allowFullScreen
        />
      </div>
    </div>
  );
}
